import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { useResizeDetector } from "react-resize-detector";

const ClickRatesBarChart = () => {
  const { ref: resizeRef, width } = useResizeDetector();

  const [range, setRange] = useState("weekly");
  const [isDark, setIsDark] = useState(false);

  /* ---------- Detect Dark Mode ---------- */
  useEffect(() => {
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  /* ---------- DATA ---------- */

  const weeklyData = [
    ["Day", "Campaigns"],
    ["Mon", 10],
    ["Tue", 15],
    ["Wed", 20],
    ["Thu", 30],
    ["Fri",20],
    ["Sat", 18],
    ["Sun", 7],
  ];

  const monthlyData = [
    ["Month", "Campaigns"],
    ["Jan", 10],
    ["Feb", 12],
    ["Mar", 18],
    ["Apr", 22],
    ["May", 14],
    ["Jun", 28],
    ["Jul", 20],
    ["Aug", 12],
    ["Sep", 17],
    ["Oct", 21],
    ["Nov", 24],
    ["Dec", 20],
  ];

  const data = range === "weekly" ? weeklyData : monthlyData;

  /* ---------- OPTIONS ---------- */

  const options = {
    backgroundColor: "transparent",
    chartArea: { width: "80%", height: "70%" },

    legend: {
      position: "bottom",
      textStyle: {
        color: isDark ? "#cbd5f5" : "#475569",
        fontSize: 11,
        fontName: "Poppins",
      },
    },

    hAxis: {
      gridlines: {
        color: isDark ? "#334155" : "#e5e7eb",
      },
      textStyle: {
        color: isDark ? "#cbd5f5" : "#475569",
        fontSize: 10,
        fontName: "Poppins",
      },
    },

    vAxis: {
      minValue: 0,
      ticks: [0, 5, 10, 15, 20, 25, 30],
      gridlines: {
        color: isDark ? "#334155" : "#e5e7eb",
      },
      textStyle: {
        color: isDark ? "#cbd5f5" : "#475569",
        fontSize: 10,
        fontName: "Poppins",
      },
    },

    colors: ["#2563eb"],
    bar: { groupWidth: "60%" },
  };

  return (
    <div
      ref={resizeRef}
      className="
        w-full
        h-[388px]
        p-4
        rounded-xl
        bg-white dark:bg-slate-800
        shadow
        border border-slate-200 dark:border-slate-700
      "
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-5">
        <h6 className="m-0 text-base font-medium text-slate-800 dark:text-slate-200">
          Department-wise Click Rates
        </h6>

        <select
          value={range}
          onChange={(e) => setRange(e.target.value)}
          className="
            text-xs px-2 py-1 rounded
            border border-slate-300 dark:border-slate-600
            bg-white dark:bg-slate-900
            text-slate-900 dark:text-slate-200
            focus:outline-none
          "
        >
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      {/* Chart */}
      {width > 0 && (
        <Chart
          chartType="ColumnChart"
          height="310px"
          data={data}
          options={options}
          loader={
            <div className="text-sm text-slate-500 dark:text-slate-400">
              Loading Chart...
            </div>
          }
        />
      )}
    </div>
  );
};

export default ClickRatesBarChart;